/* Model */
class ExternalStorageModel extends App.Models.BaseModel {
    modelUrl = 'ExternalStorage';
}

App.Models.ExternalStorage = ExternalStorageModel;

/* Collection */
class ExternalStorageCollection extends App.Collections.BaseCollection {
    url = 'ExternalStorage';
    model = App.Models.ExternalStorage;
}

App.Collections.ExternalStorages = ExternalStorageCollection;
